import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../../modules/infra/i18n';

const LoginButton = ({ login, clicked }) => (
  <button
    type="button"
    onClick={login}
    disabled={clicked}
    className="c-btn c-btn--default c-btn--small"
  >
    {t('admin:users.add.login_button')}
  </button>
);

LoginButton.propTypes = {
  login: PropTypes.func.isRequired,
  clicked: PropTypes.bool.isRequired,
};

LoginButton.defaultProps = {
  login: () => {},
  clicked: false,
};

export default LoginButton;
